module.exports = __webpack_public_path__ + "static/media/img-lazy-loading.c60ed34b.svg";